module.exports = __webpack_public_path__ + "static/02-05e0babb8d7b12be9a0d2e949cf86c18.jpg";